/*
 * @Author: ZS
 * @Date: 2020-06-23 16:56:46
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-14 10:34:13
 * @Description: file content
 */
import Vue from 'vue';
import Vuex from 'vuex';
import {
  ywtbRequest
} from '../api/axios'

Vue.use(Vuex);
export default new Vuex.Store({
  // 设置属性
  state: {
    isLogin: false,
    userId: '0325',
    nickName: '李四',
    roleName: '管理员',
    departName: '',
    // 网站信息
    webInfo: {}
  },

  // 获取属性的状态
  getters: {
    //获取登录状态
    isLogin: state => state.isLogin,
  },

  // 设置属性状态
  mutations: {
    //临时登录测试用
    changeLogin(state) {
      // state.isLogin = !state.isLogin
      // ywtbRequest('/portal-ywtb/web/getSession').then(res => {
      //   // console.log(res)
      //   if (res.status == '5301') {
      //     state.isLogin = false
      //   } else if (res.status == '200') {
      //     state.isLogin = true
      //     state.userId = res.data.userCode
      //      state.nickName = res.data.userName
      //      state.roleName = res.data.listRole
      //      state.departName = res.data.listDepartment

      //   } else {
      //     state.isLogin = false
      //   }
      // })
      let res = JSON.parse(localStorage.getItem("res"))
      if (res.status == '200') {
         state.isLogin = true
         state.userId = res.data.userCode
         state.nickName = res.data.userName
         state.roleName = res.data.listRole
         state.departName = res.data.listDepartment
      } else {
        state.isLogin = false
      }
    },
    /**
     * @name changeWebInfo
     * @description 更改网站信息
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-11-11 10:13:40
     */
    changeWebInfo(state, data) {
      state.webInfo = data;
    }

  },

  // 应用mutations
  actions: {

  }
})



// WEBPACK FOOTER //
// ./src/store/store.js